import { render, staticRenderFns } from "./SectionSelect.vue?vue&type=template&id=05487e10&scoped=true&"
import script from "./SectionSelect.vue?vue&type=script&lang=js&"
export * from "./SectionSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05487e10",
  null
  
)

export default component.exports